//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { server } from "@/services/constants";

export default {
  name: "incorporate-matter-entity-select",
  data() {
    return {
      entityTypes: [
        {
          value: "Limited Company",
          name: "Limited Company",
          nameTh: "บริษัทจำกัด",
          icon: "🏭",
        },
        {
          value: "Public Company Limited",
          name: "Public Company Limited",
          nameTh: "บริษัทมหาชนจำกัด",
          icon: "🏦",
        },
        {
          value: "Foundation",
          name: "Foundation",
          nameTh: "มูลนิธิ",
          icon: "❤️",
        },
        {
          value: "Representative Office",
          name: "Representative Office",
          nameTh: "สำนักงานผู้แทนการค้า",
          icon: "🌐",
        },
        {
          value: "Individual",
          name: "Individual",
          nameTh: "บุคคลธรรมดา",
          icon: "👤",
        },
      ],
    };
  },
  async beforeCreate() {
    this.$store.state.navMenu = true;
  },
  async mounted() {
    this.$hideLoader();
  },
  methods: {
    selectEntityType(entityType) {
      this.$router.push(
        `/incorporate-matter-add/${encodeURIComponent(entityType)}`,
      );
    },
  },
};
